/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { string, any, objectOf, func, object, bool, element } from 'prop-types';
import { get, isEmpty } from 'lodash';
import queryString from 'query-string';
import SponsorsBand from '../molecules/sponsors-band';
import CardImage from '../atoms/cardimage';
import Footer from '../story/footer/footer';
import Sidebar from '../story/sidebar/sidebar';
import Authors from '../story/authors/authors';
import PublishedInfo from '../story/published-info/published-info';
import Share from '../story/share/share';
import OpinionBadge from '../story/opinion-badge/opinion-badge';
import ShareFloatingExpanded from '../story/share/share-floating-expanded';
import AdWithPlaceholder from '../molecules/ad-with-placeholder';
import { hasSection } from '../../helpers/story-helpers';
import { syndicatedSource, checkCookie, getStoryDate, checkGeoBlock } from '../../helpers/utils';
import { trackUserInteraction } from '../../helpers/datalayer-utils';
import { WithLazy } from '@quintype/components';
import BreadcrumbBasic from '../atoms/breadcrumb-basic';
import TrackVisibility from '../track-visibility';
import VideosWidget from '../molecules/videos-widget';
import MailmodoNewsLetter from '../molecules/newsletter/mailmodo-news-letter';
import LatestNewsWidget from '../story/latest-news-widget';
import { KeyHighlights } from '../molecules/key-highlight';
import { ClockOutlineIcon } from '../atoms/material-icons';
import ContentNotAvailable from '../story/contentnotavailable/contentnotavailable';
import './story-base-template.m.css';
import ExpandVideosWidget from '../story/expand-videos-widget/expand-videos-widget';
import BudgetStrip2023 from '../collection-templates/budget-strip-2023';
import HardPaywall from '../story/story-paywall/hard-paywall';
import { isDesktop } from 'react-device-detect';
import { useGoogleOneTapLogin } from '@react-oauth/google';
import { getSSORedirectUrl } from '../../helpers/subscription-helper';

const storyShareClickHandler = (storyContentId, storyUrl) => (event) =>
  global.app.registerStoryShare(
    storyContentId,
    event.currentTarget.getAttribute('data-social-media-type'),
    storyUrl,
  );

function addLinkToCopy() {
  var bodyElement = document.getElementsByTagName('body')[0];
  var selection = window.getSelection();
  var pagelink =
    "<br /><br /> Read more at: <a href='" +
    document.location.href +
    "'>" +
    document.location.href +
    '</a><br />Copyright &copy; NDTV Profit';
  var copytext = selection.toString().substring(0, 400) + pagelink;
  var newdiv = document.createElement('div');
  newdiv.style.position = 'absolute';
  newdiv.style.left = '-99999px';
  bodyElement.appendChild(newdiv);
  newdiv.innerHTML = copytext;
  selection.selectAllChildren(newdiv);
  window.setTimeout(function () {
    bodyElement.removeChild(newdiv);
  }, 0);
}

const StoryBaseTemplate = (props) => {
  const [isGeoBlock, setIsGeoBlock] = useState(false);
  const sectionSlug = get(props, ['story', 'sections']).map((item) => item.slug);
  const [showFloatingSocial, setShowFloatingSocial] = useState(false);
  const [oneTapDisable, setOneTapDisable] = useState(true);
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], false));
  const isLoggedIn = useSelector((state) => get(state, ['userData', 'isLoggedIn'], false));
  const SSO_ONE_TAP_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'google_one_tap_url'], null),
  );
  const SSO = useSelector((state) => get(state, ['qt', 'config', 'integrations', 'sso'], null));

  useEffect(() => {
    document.oncopy = addLinkToCopy;
    const queryObject = queryString.parse(window.location.search);
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    if (queryObject.utm_source === 'wru') {
      const datalayerFields = {
        category: 'article page',
        action: 'Recommended for you',
        label: get(props, ['story', 'headline'], ''),
        event: 'event articlepage',
        cd22: 'link',
        cd23: 'bottom more on this topic',
        cd24: 'NA',
        cd26: syndicatedSource(get(props, 'story', null)),
        cd31: get(props, ['story', 'story-template'], 'text'),
        cd35: 'wru',
        cd34: 'NA',
      };
      trackUserInteraction(datalayerFields);
    }
    if (window.history.length === 1) {
      const _datalayerFields = {
        event: 'event Back button clicked',
        label: 'back button',
        action: 'click',
      };
      (function (window, location) {
        history.replaceState(null, document.title, location.pathname + '#!/homepage');
        history.pushState(null, document.title, location.pathname);

        window.addEventListener(
          'popstate',
          function () {
            if (location.hash === '#!/homepage') {
              history.replaceState(null, document.title, location.pathname);
              trackUserInteraction(_datalayerFields);
              setTimeout(function () {
                location.replace('https://www.ndtvprofit.com/');
              }, 0);
            }
          },
          false,
        );
      })(window, location);
    }
    const GeoTag = checkCookie('GeoTag');
    const GeoBlock = checkGeoBlock(GeoTag, props?.story);
    setIsGeoBlock(GeoBlock);

    if (window.location.pathname.includes('research-reports')) {
      window.localStorage.setItem(
        'storyInfo',
        JSON.stringify({
          type: 'text',
          authorName: props?.story?.['author-name'],
        }),
      );
    } else {
      window.localStorage.removeItem('storyInfo');
    }
  }, []);

  const textSelection = !props.textSelectionEnabled ? 'disable-selection' : '';
  const datalayerFields = {
    category: 'article page',
    action: 'NA',
    label: props.story.headline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'NA',
    cd24: 'NA',
    cd26: syndicatedSource(props.story),
    cd31: props.story['story-template'] || 'text',
    cd35: 'NA',
    cd34: 'NA',
  };

  const getHeroImageCaption = () => {
    let heroImageCaption =
      get(props, ['story', 'hero-image-caption'], null) ||
      get(
        props,
        ['story', 'alternative', 'home', 'default', 'hero-image', 'hero-image-caption'],
        '',
      );

    heroImageCaption =
      heroImageCaption &&
      heroImageCaption
        .replace(/<div class="paragraphs"><p>/gi, '')
        .split('</p></div>')
        .join(' ')
        .split('<br>')
        .join(' ');

    return heroImageCaption ? (
      <div styleName="hero-image-caption" dangerouslySetInnerHTML={{ __html: heroImageCaption }} />
    ) : (
      <></>
    );
  };

  const PublisherAndSocialShareSection = () => {
    return (
      <div>
        <div styleName="story-content-head-first-fold"></div>
        <div styleName="story-content-head">
          <div styleName="author-and-published-time">
            <Authors
              storyId={props.story.id}
              authors={props.story.authors}
              datalayerFields={datalayerFields}
              alt="BQ"
            />
            <span
              styleName="story-published-date"
              dateTime={new Date(props.story['first-published-at'])
                .toISOString()
                .replace('Z', '+05:30')}
            >
              <ClockOutlineIcon size="18px" color="var(--regent-gray)" />
              <span styleName="story-date">{getStoryDate(props.story['last-published-at'])} </span>
              <span className="icon-ic_info_outline" styleName="story-date-info-icon"></span>
              <div styleName="popover-story-dates">
                <PublishedInfo
                  publishedAt={props.story['first-published-at']}
                  updatedAt={props.story['last-published-at']}
                />
              </div>
            </span>
          </div>
          <div styleName="share-floating-expanded">
            <div
              styleName="g-news"
              onClick={() =>
                window.open(
                  'https://news.google.com/publications/CAAqBwgKMKr0kAsw9JylAw?hl=en-IN&gl=IN&ceid=IN%3Aen',
                  '_blank',
                )
              }
            >
              <i styleName="icon" className="icon-ic_google-news" />
            </div>
            <Share
              datalayerFields={datalayerFields}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram']}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`,
              )}
              source="story-content-head"
              expanded={true}
              alignType="horizontal"
              showToggleWhenExpanded={false}
              bookmark={props.bookmark}
            />
          </div>

          {showFloatingSocial ? (
            <ShareFloatingExpanded
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram', 'copy']}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`,
              )}
              storyId={get(props, ['story', 'id'])}
              bookmark={props.bookmark}
              story={props.story}
            />
          ) : null}
        </div>
      </div>
    );
  };

  const isBudgetStory =
    get(props, ['story', 'sections'])
      .map((item) => item.slug)
      .includes('budget') ||
    get(props, ['story', 'sections'])
      .map((item) => item.slug)
      .includes('budget-2023') ||
    get(props, ['story', 'sections'])
      .map((item) => item.slug)
      .includes('budget-2024');
  const isBrandStudioStory = get(props, ['story', 'author-name']) === 'NDTV Profit Brand Studio';
  const isLiveBlog = get(props, ['story', 'story-template']) === 'live-blog';
  const isVideoStory = get(props, ['story', 'story-template']) === 'video';
  const noHeroImage =
    get(props, ['story', 'hero-image-s3-key']) === null &&
    !isEmpty(get(props, ['story', 'alternative'])) &&
    !!get(props, ['story', 'alternative', 'home', 'default', 'hero-image', 'hero-image-s3-key']);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderAdBelowHeroImage = () => (
    <div
      styleName="BelowHeroImage-ad"
      className="content-center mobile-only"
      style={{ minHeight: '280px' }}
    >
      {isMobile && (
        <AdWithPlaceholder
          adtype="RightSidebar"
          height="280px"
          width="336px"
          adUnit="Top_300x250"
          sizes={[
            [300, 250],
            [336, 280],
          ]}
        />
      )}
    </div>
  );

  function loadTaboolaScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
    window._taboola = window._taboola || [];
    _taboola.push({
      mode: 'thumbnails-base-mode',
      container: 'taboola-below-article-thumbnails',
      placement: 'Below Article Thumbnails',
      target_type: 'mix'
    });
    window._taboola.push({flush: true});
  `;
    document.body.appendChild(script);
  }

  useEffect(() => {
    const loadTaboolaOnScroll = () => {
      loadTaboolaScript();
      window.removeEventListener('scroll', loadTaboolaOnScroll);
    };

    window.addEventListener('scroll', loadTaboolaOnScroll);

    return () => {
      window.removeEventListener('scroll', loadTaboolaOnScroll);
    };
  }, []);

  useEffect(() => {
    const temp = setTimeout(() => setOneTapDisable(false), 5000);
    return () => clearTimeout(temp);
  }, []);

  // const hideShowGooglePrompt = () => {
  //   if (typeof window !== 'undefined') {
  //     const hideOneTap = window?.document !== undefined && window?.document?.cookie
  //     .split(";")
  //     .find((c) => c.indexOf("hideOneTap") > -1);
  //     if (!!hideOneTap || oneTapDisable) {
  //       return true;
  //     } else {
  //       return !!isLoggedIn;
  //     }
  //   }
  // };

  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      if (credentialResponse.credential) {
        getSSORedirectUrl(new URL(window?.location?.href)).then((redirectUrl) => {
          window.location.href = `${SSO_ONE_TAP_URL}?credential=${credentialResponse.credential}&clientId=${SSO.client_id}&clientSecret=${SSO.client_secret}&clientRedirecturl=${redirectUrl}`;
        });
      } else {
        console.log('Unable to receive credential');
      }
    },
    onError: () => {
      console.log('Google one tap Login Failed');
    },
    cancel_on_tap_outside: true,
    disabled: !!isLoggedIn,
    use_fedcm_for_prompt: true,
  });

  return (
    <>
      <BreadcrumbBasic story={props?.story} />
      <article id={`story-${props.story.id}`} className="story-page container">
        {!isGeoBlock && (
          <>
            {isBudgetStory && (
              <div styleName="story-budgetstrip-wrapper">
                <BudgetStrip2023 />
              </div>
            )}
            <div className="desktop-only">
              {isDesktop && (
                <div styleName="add-with-grey-background">
                  <div className="responsive-ad content-center">
                    <AdWithPlaceholder
                      adtype="AboveArticleHeadline"
                      height="90px"
                      width="970px"
                      adUnit="Top_728x90"
                      sizes={[
                        [728, 90],
                        [970, 90],
                      ]}
                    />
                  </div>
                </div>
              )}
            </div>
            <div styleName="story-content" className={textSelection}>
              <div styleName="story-header-text" className="container">
                <h1 styleName="story-headline">{props.story.headline}</h1>

                <div styleName="story-subtext-wrapper">
                  <h2 styleName="story-subtext">{props.story.summary}</h2>
                  {(hasSection(props.story.sections, 'View') ||
                    hasSection(props.story.sections, 'Gadfly') ||
                    hasSection(props.story.sections, 'Opinion')) && (
                      <OpinionBadge story={props.story} />
                    )}
                </div>
                <TrackVisibility
                  onHide={() => setShowFloatingSocial(true)}
                  onVisible={() => setShowFloatingSocial(false)}
                >
                  <div className="dummy-div-for-intersection-obeserver"></div>
                </TrackVisibility>
              </div>
              <div className="container">{PublisherAndSocialShareSection()}</div>
            </div>
          </>
        )}

        <div className="row-section sidebar" styleName="story-except-headline">
          <div styleName="left-sidebar">
            <div className="reddit-card " />
            <div className="reddit-embed" />
            <canvas className="hide-element" width="1" height="1" />
            <object className="hide-element" width="1" height="1" />
            <>
              <div styleName="story-header">
                {!isGeoBlock && !noHeroImage && (
                  <div styleName="shimmer-card">
                    <div styleName="hero-image-container">
                      <CardImage
                        story={props.story}
                        aspectRatio={[16, 9]}
                        imageType="image5x2"
                        showHeroDetails={true}
                        isLazy={false}
                      />
                      {getHeroImageCaption()}
                    </div>
                  </div>
                )}

                {!isGeoBlock ? (
                  <div styleName={`body-container ${noHeroImage ? 'mt-neg' : ''}`}>
                    {!isLiveBlog && !isBrandStudioStory && renderAdBelowHeroImage()}
                    {!isSubscriber && isLiveBlog && !isBrandStudioStory && renderAdBelowHeroImage()}
                    {isLiveBlog && <KeyHighlights cards={props.story.cards} />}
                    {props.partialAccess ? (
                      <>
                        {props.content}
                        <HardPaywall story={props.story} />
                      </>
                    ) : (
                      <div>{props.content}</div>
                    )}
                  </div>
                ) : (
                  <div>
                    <ContentNotAvailable />
                  </div>
                )}
              </div>
            </>
            {!isVideoStory && (
              <div
                style={{
                  position: 'sticky',
                  top: '100px',
                  justifyContent: 'center',
                }}
              >
                <Footer
                  {...props}
                  PublisherAndSocialShareSection={PublisherAndSocialShareSection}
                  isGeoBlock={isGeoBlock}
                />
              </div>
            )}
          </div>
          {!isMobile && (
            <div className="right-sidebar">
              {!isVideoStory && (
                <div className="content-center desktop-only">
                  {isLiveBlog ? (
                    <div styleName="above-key-highlights">
                      <AdWithPlaceholder
                        adtype="AboveKeyHighlights"
                        height="250px"
                        width="300px"
                        adUnit="Top_300x250"
                        sizes={[[300, 250]]}
                      />
                    </div>
                  ) : (
                    <div styleName="above-popular">
                      <AdWithPlaceholder
                        adtype="AbovePopular"
                        height="250px"
                        width="300px"
                        adUnit="Top_300x250"
                        sizes={[[300, 250]]}
                      />
                    </div>
                  )}
                </div>
              )}
              <WithLazy>
                {() => (
                  <Sidebar
                    datalayerFields={datalayerFields}
                    story={props.story}
                    mostRead={props.mostRead}
                    isLiveBlog={isLiveBlog}
                  />
                )}
              </WithLazy>
            </div>
          )}

          <WithLazy>
            {() => (
              <>
                <div className="mobile-only">
                  <MailmodoNewsLetter
                    heading="Get market moving news, top news & compelling perspectives"
                    footerText1="We Promise. No Spam !"
                    footerText2="View All Newsletters"
                    page="story"
                  />
                  <div
                    className="responsive-ad content-center mobile-only"
                    styleName="bottom300x250ad"
                  >
                    <AdWithPlaceholder
                      adtype="midMrec"
                      height="280px"
                      width="100%"
                      adUnit="Bottom_300x250"
                      sizes={[
                        [300, 250],
                        [336, 280],
                      ]}
                    />
                  </div>
                  <ExpandVideosWidget />
                  <VideosWidget />
                </div>
                <div className="desktop-only" style={{ position: 'relative' }}>
                  <MailmodoNewsLetter
                    heading="Get market moving news, top news & compelling perspectives"
                    footerText1="No Spam. Just great journalism in your inbox"
                    footerText2="View All Newsletters"
                    page="story"
                  />
                </div>
              </>
            )}
          </WithLazy>
          <WithLazy>
            {() => (
              <div styleName="recomended-for-you-piano">
                <LatestNewsWidget story={props.story} />
              </div>
            )}
          </WithLazy>
          {!isBrandStudioStory && (
            <div id="taboola-below-article-thumbnails" styleName="taboola"></div>
          )}
        </div>
      </article>
    </>
  );
};

StoryBaseTemplate.propTypes = {
  publisherUrl: string.isRequired,
  story: objectOf(any).isRequired,
  content: element.isRequired,
  previewContent: element.isRequired,
  partialContent: element,
  textSelectionEnabled: bool.isRequired,
  cardOrder: string,
  orderChanged: func,
  hasAccess: bool,
  member: object,
  isLoading: bool,
  updateAccess: func,
  mostRead: object,
  partialAccess: bool,
  amazon_polly: bool,
  bookmark: bool,
};

StoryBaseTemplate.defaultProps = {
  cardOrder: '',
  orderChanged: () => { },
};

const mapStateToProps = (state) => ({
  publisherUrl: state.qt.config['sketches-host'],
  textSelectionEnabled: state.qt.config.features.story.text_selection.enabled,
  amazon_polly: get(state.qt, ['config', 'features', 'amazon_polly', 'enabled'], false),
  bookmark: get(state, ['qt', 'config', 'features', 'bookmark', 'enabled'], false),
  budgetBanner: get(state.qt, ['config', 'features', 'budget', 'story-budget-banner'], false),
});

export default connect(mapStateToProps, {})(StoryBaseTemplate);
